import dayjs from 'dayjs'
import {
  formatMinutes,
  formatTime
} from 'screens/Rostering/Reconciliation/reconciliationUtils'
import type {
  PayReportBreakdownPaidTimeMode,
  PayReportDrawerApiRow,
  PayReportDrawerTableRow
} from '../types/payReportDrawer'

function payByToPaidTimeMode(
  payBy: PayReportDrawerApiRow['payBy']
): PayReportBreakdownPaidTimeMode | undefined {
  if (payBy == null) {
    return undefined
  }
  const key = String(payBy).toUpperCase()
  if (key === 'DONT_PAY') {
    return 'not_paid'
  }
  if (key === 'PLANNED_TIME') {
    return 'planned'
  }
  if (
    key === 'ACTUAL_TIME' ||
    key === 'CUSTOM_PAID_TIME' ||
    key === 'CUSTOM_AMOUNT'
  ) {
    return 'actual'
  }
  return undefined
}

function getPayRateTypeLabel(
  row: PayReportDrawerApiRow
): 'GBP/hour' | 'GBP fixed' {
  const type = row.payRateType?.toUpperCase()
  if (type === 'EVENT' || type === 'FIXED') {
    return 'GBP fixed'
  }
  if (row.payBy === 'custom_amount' || row.payBy === 'CUSTOM_AMOUNT') {
    return 'GBP fixed'
  }
  return 'GBP/hour'
}

function formatPayRateDisplay(row: PayReportDrawerApiRow): string {
  if (!row.payRate || row.payRate === '-') {
    return '-'
  }
  return `${row.payRate} ${getPayRateTypeLabel(row)}`
}

export function mapDrawerApiRowsToTable(
  rows: PayReportDrawerApiRow[]
): PayReportDrawerTableRow[] {
  return rows.map((row) => {
    const start = row.plannedTime?.start
    const end = row.plannedTime?.end
    const dur = row.plannedTime?.durationMinutes

    const sortDateTime = start
      ? dayjs(start).toISOString()
      : dayjs(row.date).startOf('day').toISOString()

    const paidTimeMode = payByToPaidTimeMode(row.payBy)

    const paidTimeRange =
      start && end ? `${formatTime(start)}-${formatTime(end)}` : undefined

    const paidDuration =
      dur != null && Number.isFinite(dur) ? formatMinutes(dur) : undefined

    const subject = row.subject
      ? {
          id: row.subject.id,
          name: row.subject.name,
          picture: row.subject.picture,
          deleted: row.subject.deleted,
          status: row.subject.status
        }
      : null

    return {
      id: row.instanceId,
      date: row.date,
      sortDateTime,
      serviceUser: subject,
      eventTypeName: row.eventType.name,
      eventKind: row.type === 'visit' ? 'visit' : 'shift',
      paidTimeMode,
      paidTimeRange,
      paidDuration,
      paidDurationMinutes: dur != null && Number.isFinite(dur) ? dur : null,
      payRate: formatPayRateDisplay(row),
      payAmount: row.careDeliveryPay ?? '-',
      travelTimePay: row.travelTimePay ?? '0.00',
      mileagePay: '-',
      totalPay: row.totalPay ?? '-'
    }
  })
}
